import { createSlice } from '@reduxjs/toolkit';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    isAuthenticated: false,
    userName: '',
    error: {}
  },
  reducers: {
    setAuthenticated: (state, action) => {
      state.isAuthenticated = true;
      state.userName = action.payload.displayName;
    },
    setNotAuthenticated : state => {
      state.isAuthenticated= false;
      state.userName = '';
    },
  },
});

export const { setAuthenticated, setNotAuthenticated } = appSlice.actions;

export const isAuthenticated = state => state.app.isAuthenticated;
export const userName = state => state.app.userName;

export default appSlice.reducer;
